import Emitter from "./Emitter";

export default class UrlChanged extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(data) {
        if (data) {
            this.emitTop({ wpgaction: "urlChanged.parent", data:data });
            this.emitParent({ wpgaction: "urlChanged", data:data });
            this.emitiOS({ wpgaction: "urlChanged", data:data });
        } else {
            this.emitTop({ wpgaction: "urlChanged.parent"});
            this.emitParent({ wpgaction: "urlChanged"});
            this.emitiOS({ wpgaction: "urlChanged"});
        }
    }
}